var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step",class:_vm.item.fields[0].schema.this_stage.text == '1' ? 'current-step' : '',on:{"click":function($event){return _vm.callPopup(_vm.item.intents)}}},[_c('div',{staticClass:"step__title"},[_c('div',{staticClass:"step-block__name"},[_c('p',{staticClass:"step__name"},[_vm._v(_vm._s(_vm.stageName))]),(_vm.item.fields[0].schema.required_to_pass.text == '1')?_c('p',{staticClass:"step__required"},[_vm._v(" * ")]):_vm._e()]),(
        _vm.item.fields[0].schema.sla_error &&
        _vm.item.fields[0].schema.sla_error.text
      )?_c('Tooltip',{attrs:{"content":_vm.item.fields[0].schema.sla_error.text,"disabled":false,"effect":"dark"}},[_c('Icon',{attrs:{"iconName":"CircleWarning","iconColor":"#FC311E"}})],1):_vm._e()],1),(
      _vm.item.fields[0].schema.sla_expired ||
      _vm.item.fields[0].schema.sla_last_day ||
      _vm.item.fields[0].schema.sla_left
    )?_c('div',{class:[
      'step-sla',
      _vm.item.fields[0].schema.sla_expired.text
        ? 'step-sla--red'
        : _vm.item.fields[0].schema.sla_last_day.text
        ? 'step-sla--yellow'
        : _vm.item.fields[0].schema.sla_left.text
        ? 'step-sla--grey'
        : ''
    ]},[_vm._v(" "+_vm._s(_vm.item.fields[0].schema.sla_expired.text || _vm.item.fields[0].schema.sla_last_day.text || _vm.item.fields[0].schema.sla_left.text)+" ")]):_vm._e(),(
      _vm.stageStatus &&
      ((_vm.item.fields[0].schema.this_stage.text == '1' &&
        _vm.stageStatusData?.access) ||
        _vm.stageStatusData?.value)
    )?_c('div',{staticClass:"step-status"},[_c('p',[_vm._v("Статус")]),(
        _vm.item.fields[0].schema.this_stage.text == '1' && _vm.stageStatusData.access
      )?_c('Dropdown',{attrs:{"size":"status","options":_vm.statusOptions || [],"clearable":false,"field":{ type: 'enum', disabled: false, placeholder: 'Не выбран' },"model":_vm.stageStatusData.value || ''},on:{"set-value":(name, value) => _vm.setValue(value)}}):(_vm.stageStatusData?.value)?_c('Tooltip',{attrs:{"content":_vm.statusSelectedOption,"disabled":_vm.statusSelectedOption.length < 15,"effect":"dark"}},[_c('div',{staticClass:"step-status__name"},[_vm._v(" "+_vm._s(_vm.statusSelectedOption || '')+" ")])]):_vm._e()],1):_vm._e(),_c('div',{staticClass:"step-info"},[_c('div',{staticClass:"step-info__left"},[_c('Picture',{class:_vm.iconColor(),attrs:{"url":_vm.stageIcon ? _vm.stageIcon : ''}}),_c('p',{staticClass:"step__date"},[_vm._v(_vm._s(_vm.stageDate))])],1),(_vm.stageAttachment && _vm.stageAttachmentText)?_c('a',{staticClass:"step__attachment",on:{"click":event => {
          event.stopPropagation();
          if (
            _vm.item.fields &&
            _vm.item.fields.length &&
            _vm.item.fields[1].linked_field &&
            _vm.item.fields[1].linked_field.intents
          ) {
            _vm.item.fields[1].linked_field.intents[0].intentArea === 'OldPage'
              ? _vm.goToOldPage(_vm.item.fields[1].linked_field.intents[0])
              : _vm.item.fields[1].linked_field.intents[0].intentArea ===
                'OuterPage'
              ? _vm.openInNewWindow(_vm.item)
              : _vm.callPopup(_vm.item.fields[1].linked_field.intents);
          }
        }}},[_vm._v(" "+_vm._s(_vm.formatHtml(_vm.stageAttachmentText))+" ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }